"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgLowNoiseOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.low-noise_outline_svg__cls-1{display:none}')),
        React.createElement("g", { id: "low-noise_outline_svg__transparent_box" },
            React.createElement("path", { className: "low-noise_outline_svg__cls-1", d: "M0 0h32v32H0z" }),
            React.createElement("path", { className: "low-noise_outline_svg__cls-1", d: "M0 0h32v32H0z" })),
        React.createElement("g", { id: "low-noise_outline_svg__OUTLINE" },
            React.createElement("path", { d: "M4 9v14h7.71L21 28.8V3.2L11.71 9zm2 2h5v10H6zm13 14.2l-6-3.75v-10.9l6-3.75zM26.36 9.64l-1.42 1.41a7 7 0 010 9.9l1.42 1.41a9 9 0 000-12.72z" }))));
}
exports.default = SvgLowNoiseOutline;
//# sourceMappingURL=LowNoiseOutline.js.map